import React from 'react';
import PropTypes from 'prop-types';
import MarkdownArtifact from './MarkdownArtifact';
import ArtifactRenderer from './ArtifactRenderer';
import css from './ArtifactWithInsights.css';
import Icon, { IconSizes } from '../../../components/foundations/Icon';

const ArtifactWithInsights = ({ artifact }) => {
    const title = artifact?.metadata?.title;
    return (
        <div className={css.artifactWithInsights}>
            {title && <div className={css.title}>{title}</div>}
            <ArtifactRenderer artifact={artifact} />
            {artifact.insights && (
                <div className={css.insights}>
                    <div className={css.insightsHeader}>
                        <Icon name="sparkles" size={IconSizes.MEDIUM} className={css.headerIcon} />
                        <span className={css.headerTitle}>INSIGHTS</span>
                    </div>
                    <MarkdownArtifact artifact={{ data: artifact?.insights }} />
                </div>
            )}
        </div>
    );
};

ArtifactWithInsights.propTypes = {
    artifact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        insights: PropTypes.string,
        metadata: PropTypes.any,
    }).isRequired,
};

export default ArtifactWithInsights;
